import client from '../client';
import type { ApiResponse } from '../../types/api';
import type { EmailEditorState } from '../../components/email-editor/types';

export interface SavedEmailTemplate {
  _id: string;
  storeId: string;
  name: string;
  templateType: string;
  subject: string;
  greeting: string;
  bodyHtml: string;
  ctaText: string;
  ctaUrl: string;
  colors: Record<string, string>;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

export const emailTemplatesApi = {
  list: async (storeId: string) => {
    const res = await client.get<ApiResponse<{ templates: SavedEmailTemplate[] }>>(
      `/dashboard/${storeId}/email-templates`,
    );
    return res.data.data!;
  },

  save: async (storeId: string, data: { name: string } & Partial<EmailEditorState>) => {
    const res = await client.post<ApiResponse<{ templateId: string }>>(
      `/dashboard/${storeId}/email-templates`,
      data,
    );
    return res.data.data!;
  },

  update: async (storeId: string, templateId: string, data: Partial<EmailEditorState> & { name?: string }) => {
    await client.patch(`/dashboard/${storeId}/email-templates/${templateId}`, data);
  },

  delete: async (storeId: string, templateId: string) => {
    await client.delete(`/dashboard/${storeId}/email-templates/${templateId}`);
  },
};
